<template>
  <div>
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft"
    >
      <template #left>
        <img
          src="../assets/img/pet-info/editinfo-left-icon.png"
          alt=""
        />
      </template>
      <template #title>
        <a href="https://pawaiipets.com">
          <img
            src="../assets/img/pet-info/pawaii-logo.png"
            alt=""
          />
        </a>
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="email">{{ userEmail }}</div>
      <van-row>
        <van-button
          type="info"
          @click="arriveInfo"
          class="edit-button"
        >Edit the information</van-button>
      </van-row>
      <van-row>
        <van-button
          type="info"
          class="change-button"
          @click="goChangePassword"
        >Change your password</van-button>
      </van-row>
      <van-row>
        <van-button
          type="info"
          @click="logOut"
          class="logout-button"
        >Log out</van-button>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Edit",
  data() {
    return {
      userEmail: "",
    };
  },
  created() {
    // 获取用户Email信息
    this.userEmail = window.sessionStorage.getItem("usereamil");
  },
  methods: {
    // 导航栏左上角点击
    onClickLeft() {
      this.$router.go(-1);
    },
    // 忘记密码跳转
    goChangePassword() {
      this.$router.push({
        path: "/reset",
      });
    },
    // 索引页跳转
    arriveInfo() {
      this.$router.push({
        path: "/select",
      });
    },
    // 退出
    logOut() {
      //清空token
      sessionStorage.clear();
      location.href='https://pawaiipets.com/pet-finder';
      // this.$router.push({
      //   path: "/login",
      // });
    },
  },
};
</script>

<style scoped>
.van-nav-bar {
  background-color: #1a1a1a;
}
.van-nav-bar__title img {
  padding-top: 5px;
  width: 50px;
}
.van-nav-bar__left img {
  width: 24px;
}
.van-nav-bar__right img {
  width: 24px;
}
.content {
  width: 91.466vw;
  margin: 0 auto;
  padding-top: 26px;
}
.email {
  font-weight: 500;
  font-size: 6.4vw;
  line-height: 120%;
  color: #222222;
  font-family: Poppins-Medium;
  padding-bottom: 24px;
}
.van-button {
  width: 100%;
  height: 48px;
  border-radius: 48px;
  margin-bottom: 16px;
}
.edit-button {
  color: #ffffff;
  background-color: #ff5349;
  border: 0;
}
.change-button {
  color: #ff5349;
  border: 1px solid #ff5349;
  background-color: #ffffff;
}
.logout-button {
  color: #999999;
  border: 1px solid #c4c4c4;
  background-color: #ffffff;
}
</style>